export const DEFAULT_TABLE_PAGE_SIZE = 50;
export const DEFAULT_DROPDOWN_PAGE_SIZE = 20;
